import { Box, BoxProps } from "@hightouch/htui";

export function GoogleLogo(props: BoxProps) {
  return (
    <Box
      as="svg"
      width="20px"
      height="20px"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="#4285F4"
        d="M18 10.184c0-.544-.046-1.09-.142-1.626H10.16v3.08h4.409a3.7 3.7 0 0 1-1.632 2.432v1.999h2.63C17.112 14.675 18 12.618 18 10.184Z"
      />
      <path
        fill="#34A853"
        d="M10.16 18c2.201 0 4.057-.709 5.41-1.931l-2.63-2c-.732.489-1.677.765-2.777.765-2.13 0-3.935-1.408-4.583-3.3H2.866v2.06C4.252 16.295 7.074 18 10.16 18Z"
      />
      <path
        fill="#FBBC04"
        d="M5.578 11.533a4.702 4.702 0 0 1 0-3.063V6.41H2.867a7.865 7.865 0 0 0 0 7.184l2.71-2.061Z"
      />
      <path
        fill="#EA4335"
        d="M10.16 5.166a4.485 4.485 0 0 1 3.13 1.2l2.33-2.284A7.933 7.933 0 0 0 10.16 2C7.074 2 4.252 3.705 2.866 6.41l2.711 2.06c.645-1.896 2.453-3.304 4.583-3.304Z"
      />
    </Box>
  );
}

export function MicrosoftLogo(props: BoxProps) {
  return (
    <Box
      as="svg"
      width="20px"
      height="20px"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#microsoft__a)">
        <path fill="#F3F3F3" d="M0 0h24v24H0V0Z" />
        <path fill="#F35325" d="M1.043 1.043h10.435v10.435H1.043V1.043Z" />
        <path fill="#81BC06" d="M12.522 1.043h10.434v10.435H12.522V1.043Z" />
        <path fill="#05A6F0" d="M1.043 12.522h10.435v10.434H1.043V12.522Z" />
        <path fill="#FFBA08" d="M12.522 12.522h10.434v10.434H12.522V12.522Z" />
      </g>
      <defs>
        <clipPath id="microsoft__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </Box>
  );
}

export function BuildingIcon(props: BoxProps) {
  return (
    <Box
      as="svg"
      width="20px"
      height="20px"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.334 10a.833.833 0 0 1 0 1.667H6.667a.833.833 0 0 1 0-1.667h1.667Zm0-3.333a.833.833 0 0 1 0 1.666H6.667a.833.833 0 1 1 0-1.666h1.667Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 2.5A2.5 2.5 0 0 1 12.5 5v.833H15a2.5 2.5 0 0 1 2.5 2.5V15h.834a.833.833 0 0 1 0 1.667H1.666a.833.833 0 0 1 0-1.667H2.5V5A2.5 2.5 0 0 1 5 2.5h5ZM5 4.167A.833.833 0 0 0 4.167 5v10h6.667V5A.833.833 0 0 0 10 4.167H5ZM12.5 15h3.334V8.333A.833.833 0 0 0 15 7.5h-2.5V15Z"
        clipRule="evenodd"
      />
    </Box>
  );
}
